<form class="py-5">
  <div class="pb-5 row">
    <label hidden for="table-complete-search" class="col-xs-3 col-sm-auto col-form-label">Full text search:</label>
    <div class="col">
      <input id="table-complete-search" type="text" class="form-control" name="searchTerm"
        [(ngModel)]="service.searchTerm" placeholder="Search by email address..." />
      </div>
    </div>

    <ngb-pagination
      [collectionSize]="(total$ | async)!"
      [(page)]="service.page"
      [pageSize]="service.pageSize"
      [maxSize]="10"
      [rotate]="true"
      [ellipses]="true"
      [boundaryLinks]="true">
    </ngb-pagination>

    <table class="table table-striped">
      <thead>
        <tr>
          @for (col of columns; track col) {
            <th sortable [sortable]="col.sortableName ?? ''" (sort)="onSort($event)">
          <div [ngClass]="{
              'd-flex justify-content-center align-items-center':
                !col.sortableName
            }">
                {{ col.label }}
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (record of records$ | async; track record) {
          <tr>
            <!-- only display columns in columnDefinition -->
            @for (col of columns; track col) {
              <td>
                @if (col.sortableName && record[col.sortableName]) {
                  <ngb-highlight
                  [result]="record[col.sortableName]" [term]="service.searchTerm"></ngb-highlight>
                } @else {
                  <div class="d-flex justify-content-center align-items-center">
                    <fa-icon [icon]="col.icon" class="iconHover" (click)="handleAction(record, col)"></fa-icon>
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

    <div class="d-flex justify-content-between p-2">
      <ngb-pagination
        [collectionSize]="(total$ | async)!"
        [(page)]="service.page"
        [pageSize]="service.pageSize"
        [maxSize]="10"
        [rotate]="true"
        [ellipses]="true"
        [boundaryLinks]="true">
      </ngb-pagination>

      <select class="form-select" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
        <option [ngValue]="5">5 items per page</option>
        <option [ngValue]="10">10 items per page</option>
        <option [ngValue]="15">15 items per page</option>
      </select>
    </div>
  </form>